export default "__VITE_ASSET__BwR92gNE__"